import React, {useRef, useState} from 'react';
import clsx from 'clsx';
import {ArrowUp, ArrowDown} from '../../icons';
import {DropdownProps} from './types';
import styles from './Dropdown.module.scss';

export const Dropdown = ({label, items, className, buttonClassName,}: DropdownProps) => {

    const [open, setOpen] = useState(false);
    if (!items || items.length === 0) return null;

    return (
        <div className={clsx(styles.dropdown, className)}>
            <button
                type="button"
                className={clsx(styles.dropdown__btn, buttonClassName)}
                onClick={() => setOpen(v => !v)}
                aria-expanded={open}
            >
                <span className={styles.dropdown__label}>{label}</span>

                {open
                    ? <ArrowUp width={18} height={18} color="currentColor"/>
                    : <ArrowDown width={18} height={18} color="currentColor"/>
                }
            </button>


            <div className={styles.dropdown__menu}>
                {items.map((el, idx) => (
                    <div
                        key={idx}
                        className={styles.dropdown__item}
                        onClick={() => setOpen(false)}
                    >
                        {el}
                    </div>
                ))}
            </div>
        </div>
    );
};
